/* H2OS theme JS */
(function () {
  'use strict';

  /* ---- Menu drawer ---- */
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = document.getElementById(btn.getAttribute('data-drawer-open'));
      if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var d = el.closest('.drawer');
      if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });

  /* ---- Hotspot carousel ---- */
  document.querySelectorAll('[data-hotspots]').forEach(function (root) {
    var slides = root.querySelectorAll('.hotspots__slide');
    var spots = root.querySelectorAll('.hotspot');
    var dots = root.querySelectorAll('.hotspots__dots button');
    var cur = root.querySelector('[data-hs-cur]');
    var i = 0;
    function go(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      spots.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (cur) cur.textContent = i + 1;
    }
    spots.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.i); }); });
    dots.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.i); }); });
    root.querySelectorAll('[data-hs-dir]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + (+b.dataset.hsDir)); });
    });
  });

  /* ---- Product gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-gallery-slide]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    var i = 0;
    function set(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { set(k); }); });
    var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { set(i - 1); });
    if (next) next.addEventListener('click', function () { set(i + 1); });
    g.setVariantImage = function (mediaId) {
      slides.forEach(function (s, k) { if (String(s.dataset.mediaId) === String(mediaId)) set(k); });
    };
    set(0);
  });

  /* ---- Variant picker ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants-json]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var select = form.querySelector('.variant-select');
    var addBtn = form.querySelector('[data-add-btn]');
    var priceEl = form.querySelector('[data-price]');
    var wasEl = form.querySelector('[data-compare-price]');
    var money = form.dataset.moneyFormat || '${{amount}}';
    var gallery = document.querySelector('[data-gallery]');

    function fmt(cents) {
      var v = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/<[^>]+>/g, '');
    }
    function selected() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (grp) {
        var a = grp.querySelector('.is-active');
        opts[+grp.dataset.optionIndex] = a ? a.dataset.value : null;
      });
      return variants.find(function (v) {
        return v.options.every(function (o, k) { return o === opts[k]; });
      });
    }
    function update() {
      var v = selected();
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; return;
      }
      select.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = fmt(v.compare_at_price); wasEl.hidden = false; }
        else wasEl.hidden = true;
      }
      if (v.available) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.add; }
      else { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.soldout; }
      if (v.featured_media && gallery && gallery.setVariantImage) gallery.setVariantImage(v.featured_media.id);
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    form.querySelectorAll('[data-option-index]').forEach(function (grp) {
      grp.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]'); if (!b) return;
        grp.querySelectorAll('[data-value]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var lbl = grp.querySelector('[data-option-label]'); if (lbl) lbl.textContent = b.dataset.value;
        update();
      });
    });
    var qty = form.querySelector('.qty');
    if (qty) {
      var inp = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b, k) {
        b.addEventListener('click', function () { inp.value = Math.max(1, (+inp.value || 1) + (k ? 1 : -1)); });
      });
    }
    update();
  });

  /* ---- Sticky add-to-cart (mobile) ---- */
  var bar = document.getElementById('stickyAtc'), atc = document.querySelector('.atc');
  if (bar && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(atc);
    var stickyBtn = bar.querySelector('button');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { var b = document.querySelector('[data-add-btn]'); if (b) b.click(); });
  }

  /* ---- Cart quantity auto-submit ---- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (inp) {
    inp.addEventListener('change', function () { inp.form && inp.form.submit(); });
  });
})();
